import { PropsWithChildren } from 'react';

import css from './styles.module.css';

export type TimelineContentProps = PropsWithChildren;

/**
 * The event's body, indented under the headline. A named region rather than
 * the event's bare children because it carries its own spacing and paragraph
 * typography.
 */
export function TimelineContent({ children }: TimelineContentProps) {
  return <div className={css.content}>{children}</div>;
}
